import React from "react";
import contentWrapperStyles from "./scss/contentWrapper.module.scss";

const ContentWrapper = ({ title, children }) => {
  return (
    <main className="float-top position-relative">
      <section>
        <div className="container">
          <div className={contentWrapperStyles.siteTable}>
            <div
              className={`${contentWrapperStyles.tbaleHead} d-flex w-100 justify-content-between align-items-center`}
            >
              <h3>{title}</h3>
              <div className="select-bar">
                <select className="form-control">
                  <option value="">24H</option>
                  <option value="">12H</option>
                  <option value="">06H</option>
                  <option value="">02H</option>
                </select>
              </div>
            </div>
            {children}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContentWrapper;
